
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDeCurso } from '../../controlador-detalles';
    import { Curso } from '@/__env/lib/Cursos';
    import resumen from './cursos-detalles-resumen.vue';
    import detalles from './cursos-detalles-detalles.vue';
    import participantes from './cursos-detalles-participantes.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            resumen,
            detalles,
            participantes
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador(): ControladorDeCurso { return Model; }
        public get Curso(): Curso { return this.Controlador.Curso; }

        public Estado: string = 'cargando';
        public Modo: string = 'cargando';


        protected Eventos: Function[] = [];
        beforeDestroy() { this.Eventos.forEach( x => x() ); }
        async mounted()
        {
            this.Estado = this.Controlador.Vista.Estado;
            this.Modo = this.Controlador.Vista.Modo;
            this.Eventos.push( this.Controlador.Vista.onModo.subscribe( () => this.Modo = this.Controlador.Vista.Modo ) );
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () => this.Estado = this.Controlador.Vista.Estado ) );

            if ( parseInt( String( this.$route.query["id"] ) ) > 0 )
            {
                await this.Controlador.Iniciar( Number( this.$route.query.id ) );
            }

            this.Refrescar();
        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () =>
            {
                this.Refresh = true;
            } );
        }

    }
